import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg prose-p:text-charcoal-700/90 prose-headings:text-charcoal-800 mx-auto" data-id="element-90">
          <div className="text-center mb-12" data-id="element-91">
            <h2 className="text-sm font-bold tracking-widest text-sage-500 uppercase mb-4" data-id="element-92">
              The "Me Too" Moment
            </h2>
            <p className="text-3xl font-display italic text-charcoal-800" data-id="element-93">
              Do you wake up feeling like you've already worked a 10-hour shift?
            </p>
          </div>

          <div className="space-y-6 text-lg leading-relaxed" data-id="element-94">
            <p data-id="element-95">
              You reach for your phone, then your coffee, and by 10 AM your
              heart is racing, but your brain is in a fog. You're doing "all the
              right things"—you're hitting the gym, you're watching your
              carbs—but that stubborn midsection won't budge and your energy is
              non-existent.
            </p>

            <div className="bg-cream-dark p-8 rounded-2xl my-10 border border-cream" data-id="element-96">
              <p className="font-bold text-xl mb-4 text-coral-600" data-id="element-97">
                If this sounds like you, I have a "hard truth" to share:
              </p>
              <p className="text-xl font-display italic" data-id="element-98">
                You aren't lazy. You aren't "just getting old." And you don't
                need more discipline.
              </p>
              <p className="text-2xl font-bold mt-4 text-charcoal-800" data-id="element-99">
                You are stuck in a Cortisol Loop.
              </p>
            </div>
          </div>

          <div className="mt-20" data-id="element-100">
            <div className="text-center mb-10" data-id="element-101">
              <h2 className="text-sm font-bold tracking-widest text-coral-500 uppercase mb-4" data-id="element-102">
                The Invisible Enemy
              </h2>
            </div>

            <div className="space-y-6 text-lg leading-relaxed" data-id="element-103">
              <p data-id="element-104">
                In the US, we're taught to "hustle" through the pain. But for
                your female biology, that hustle is toxic.
              </p>
              <p data-id="element-105">
                Every cup of coffee on an empty stomach, every high-intensity
                workout when you're already stressed, and every blue-light
                scroll at 11 PM is a direct signal to your body to{' '}
                <strong className="text-coral-600" data-id="element-106">STORE FAT</strong> and{' '}
                <strong className="text-coral-600" data-id="element-107">SHUT DOWN ENERGY</strong>.
              </p>
              <p className="text-xl font-display italic border-l-4 border-sage-400 pl-6 my-8" data-id="element-108">
                Your body thinks it's under attack. And until you signal
                "SAFETY" to your nervous system, no diet in the world will work.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}